var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 35.086,
    height: 30,
    viewBox: "0 0 35.086 30",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#466DEC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "draft_icon",
    "data-name": "draft icon",
    d: "M30.288,0H6.04A3.634,3.634,0,0,0,2.412,3.629v19.38L.669,24.752,0,30l5.248-.669,1.085-1.086H30.31a3.635,3.635,0,0,0,3.629-3.629V3.629A3.667,3.667,0,0,0,30.288,0M4.544,27.86l-.094.012.011.006-2.68.341.351-2.749.324-.324v0l1.954-1.954v0l2.007-2.006,0,0,.012-.012,2.4,2.4Zm2.963-7.766,1.248-1.248a1.168,1.168,0,0,1,.235-.18,1.4,1.4,0,0,1,.294-.135,1.256,1.256,0,0,1,1.36.306l.524.524a1.271,1.271,0,0,1,.275.413,1.13,1.13,0,0,1,.07.284l.006.037a.321.321,0,0,0,.008.035.436.436,0,0,1,.016.091,1.3,1.3,0,0,1-.272.866.463.463,0,0,0-.026.042.478.478,0,0,1-.076.107L9.92,22.483,8.64,21.2l-.009.014Zm1.712,6.153a8.66,8.66,0,0,1,.08-.967l.516-.516,2.451-2.451-.007-.007.081-.09a2.868,2.868,0,0,0,.624-2.709,7.187,7.187,0,0,1,3.852-1.125h2.694a7.87,7.87,0,0,1,7.6,7.865Zm4.3-14.84a4.83,4.83,0,0,1,4.65-4.976,4.8,4.8,0,0,1,4.649,4.976,4.816,4.816,0,0,1-4.649,4.976,4.83,4.83,0,0,1-4.65-4.976M31.94,24.617h-.022a1.641,1.641,0,0,1-1.629,1.629H29.109a10.071,10.071,0,0,0-6.79-9.423,7.09,7.09,0,0,0,2.494-5.438,6.821,6.821,0,0,0-6.648-6.975,6.821,6.821,0,0,0-6.649,6.975,7.092,7.092,0,0,0,2.494,5.439,9.306,9.306,0,0,0-2.185,1.035l-.1-.1a2.845,2.845,0,0,0-3.936-.1l-.071.049-3.3,3.3V3.629A1.642,1.642,0,0,1,6.04,2H30.31a1.641,1.641,0,0,1,1.63,1.629Z",
    fill: "#89c32d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIcon);
export default __webpack_public_path__ + "static/media/DraftIcon.cf89a1bbb2427c779f6bf3050d430fac.svg";
export { ForwardRef as ReactComponent };